import { type ComponentProps, type ReactNode } from 'react'
import { Combobox } from '@base-ui/react/combobox'
import { twMerge } from 'tailwind-merge'
import { X } from 'lucide-react'
import type { PartProps } from '../../../lib/part-props'

interface ComboboxClearProps extends PartProps<ComponentProps<typeof Combobox.Clear>> {
  icon?: ReactNode
  className?: string
}

function ComboboxClear({ className, children, icon, ...props }: ComboboxClearProps) {
  return (
    <Combobox.Clear
      className={twMerge(
        'corner-smooth flex h-10 w-6 items-center justify-center rounded bg-transparent p-0',
        'text-foreground-secondary',
        className,
      )}
      {...props}
    >
      {icon || children || <X className="size-4" />}
    </Combobox.Clear>
  )
}

export { ComboboxClear }
